import { makeQueryOptions } from '@mint-lib/api-zod-support/react-query';

import { defaultApi, defaultClient } from '@mint-sdk/api-core';
import { z } from 'zod';

import {
  createdFlightVersionResponseSchema,
  flightsListItemSchema,
  flightsListSchema,
  flightVersionResponseSchema,
  updatedFlightResponseSchema,
  updateFlightRequestSchema,
} from '../shared/schemas/flights.js';

export type FlightsList = z.infer<typeof flightsListSchema>;
export type CreateFlightsResponse = z.infer<typeof flightsListItemSchema>;
export type UpdateFlightRequest = z.infer<typeof updateFlightRequestSchema>;
export type FlightVersionListResponse = z.infer<
  typeof flightVersionResponseSchema
>;

export const flightsList = defaultApi.declareEndpoint({
  url: 'planning-service/flights/' as const,
  method: 'GET',
  responseSchema: flightsListSchema,
  querySchema: z.object({
    activityId: z.string(),
  }),
  clientOptions: {
    request: {
      snakeCaseQueryParams: true,
    },
  },
});

export const createFlights = defaultApi.declareEndpoint({
  url: 'planning-service/flights/' as const,
  method: 'POST',
  responseSchema: flightsListItemSchema,
  requestSchema: z.object({
    activityId: z.string(),
    type: z.enum(['custom', 'monthly', 'quarterly']),
  }),
});

export const deleteFlights = defaultApi.declareEndpoint({
  url: 'planning-service/flights/delete_batch/' as const,
  method: 'POST',
  requestSchema: z.object({
    flightIds: z.array(z.string()),
  }),
  responseSchema: z.string(),
});

export const updateFlights = defaultApi.declareEndpoint({
  url: 'planning-service/flights/$flightId/' as const,
  method: 'PATCH',
  responseSchema: updatedFlightResponseSchema,
  requestSchema: updateFlightRequestSchema,
});

export const getFlightsListQueryOptions = makeQueryOptions(flightsList, {
  processResponse(data) {
    return data;
  },
});

export const createFlightVersion = defaultClient.mutation({
  url: 'planning-service/versions/flights/$mediaDataId/' as const,
  method: 'POST',
  responseSchema: createdFlightVersionResponseSchema,
});

export const getFlightVersionList = defaultClient.query({
  url: 'planning-service/versions/flights/$mediaDataId/' as const,
  method: 'GET',
  responseSchema: flightVersionResponseSchema,
});
